import { logger } from '@lusha/client-logger';

import AjaxUtils from './ajaxUtils';

const sendClientMetric = async (metrics, isSuccessfullyParsed) => {
  try {
    AjaxUtils.post('/api/v3/monitor-manager', { metrics, isSuccessfullyParsed });
  } catch (err) {
    logger.error('Failed to send client metrics', { err });
  }
};

export {
  sendClientMetric,
};
